export default __webpack_public_path__ + "static/media/Energy.89c0d5f7.svg";